const inicializarArrayValoresDefault = (quantidadePosicoes, valorDefault) => {
  const array = []
  for (let indice = 0; indice <= quantidadePosicoes - 1; indice++) {
    array[indice] = valorDefault
  }
  return array
}

export default {
  inicializarArrayValoresDefault
}
